import type { Locale } from "@/lib/i18n";
import { pl, type ProductCardTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const productCardTranslations: Record<Locale, ProductCardTranslations> = {
  pl,
  en,
  de,
};

export type { ProductCardTranslations };
